module.exports = __webpack_public_path__ + "img/takeunit.9d1a6bbb.png";